import { Box } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';

import PageHeader from '../helper/PageHeader';
import SimpleTable from '../helper/SimpleTable';
import styles from '../styles';
import Loading from '../helper/Loading';
import { authContext } from "../../context/AuthContext";
import DeleteDialog from '../helper/Dialogs';
import { SearchBarCatLevelRegionFirstLast } from '../helper/SearchBars';


const tableCells = [
    { id: 'username', label: 'Username', centered: false },
    { id: 'name', label: 'Name', centered: false },
    { id: 'status', label: 'Status', centered: false },
    { id: 'categoryId', label: 'Category', centered: false },
    { id: 'instructorLevel', label: 'Instructor Level', centered: false },
];

const AdminInstrucManage = props => {
    const { classes } = props
    const history = useHistory()
    const user = useContext(authContext)
    const roles = user.roles
    const enableActions = roles.isInstructorAdministrator === 1 ? true : false;

    const [data, setData] = useState(null)
    const [searchData, setSearchData] = useState({
        category: null,
        level: null,
        county: null,
        region: null,
        firstName: '',
        lastName: ''
    })
    // const [originalLength, setOriginalLength] = useState(-1) // to display the truncation amount
    const [loading, setLoading] = useState(false)
    const [deleteDialog, setDeleteDialog] = useState({open: false, user: null})
    const mounted = useRef(true)

    useEffect(() => {
        // on unmount
        return () => mounted.current = false
    }, [])

    const handleSearch = (search) => {
        setSearchData(search)
        onSearch(search)
    }

    const onSearch = (search) => {
        if(search===null) search = searchData // if this is called from delete, then delete uses the main state (searchData)
        setLoading(true)
        axios.get('/api/instructor/search', {
            params: {
                category: search.category ? search.category.value : null,
                level: search.level ? search.level.value : null,
                inStatus: search.inStatus ? search.inStatus.value : null,
                county: search.county ? search.county.value : null,
                region: search.region ? search.region.value : null,
                firstName: search.firstName,
                lastName: search.lastName
            }
        }).then((res) => {
            console.log(res.data)
            const data = res.data.instructors.map((u) => {
                u.actionsDisabled = {
                    edit: false,
                    delete: false
                }
                return u;
            })
            setData(data)
            setLoading(false)
        })
    }

    const onEdit = (user) => {
        history.push('/administration/instructor/' + user);
    }

    const openDeleteDialog = (user) => {
        setDeleteDialog({open: true, user,})
    }

    const closeDeleteDialog = () => {
        setDeleteDialog({open: false, user: null})
    }

    const onDelete = (event) => {
        axios.delete("/api/instructor/" + deleteDialog.user, {
            headers: {
                'Authorization': user.accessToken
            }
        }).then(response => {
            onSearch(null)
        })

        closeDeleteDialog() // not within the axios.then in case something goes wrong
    }

    const addInstruc = () => {
        history.push('/administration/instructors/add');
    }

    const actionButtons = [
        { icon: "edit", action: onEdit, delete: false },
        { icon: "delete", action: openDeleteDialog, delete: true },
    ];

    const onClear = () => {
        setData(null)
        setSearchData({
            category: null,
            level: null,
            county: null,
            region: null,
            firstName: '',
            lastName: ''
        })
    }

    return (
        <>
            <PageHeader
                title={"Instructor Management"}
                actionButtons={[{ label: "Add Instructor", action: addInstruc, disabled: enableActions === false }]}
            />
            <SearchBarCatLevelRegionFirstLast classes={classes} onSearch={handleSearch}  onClear={onClear}/>

            <br /><br />

            {loading ? <Loading /> : // if loading display message
                data === null ? null : // if there is no data display nothing (when first loaded in)
                    data.length === 0 ?// if there is data but it is empty
                        <Box display="flex" mt={4} justifyContent="center">
                            <h1>No Data</h1>
                        </Box>
                        :
                        <>
                            {/* {originalLength > 100 && <p>{`Found too many results (${originalLength}) limiting results to 100`}</p>} */}
                            <SimpleTable
                                data={data}
                                cellKey={"username"} //username because the delete and edit functions take in the username
                                tableCells={tableCells}
                                actionButtons={actionButtons}
                                actions={enableActions}
                            />
                            <DeleteDialog
                                open={deleteDialog.open}
                                onClose={closeDeleteDialog}
                                onDelete={onDelete}
                            />
                        </>
            }
        </>
    )
}

export default withStyles(styles, { withTheme: true })(AdminInstrucManage)